import { Injectable, Inject } from '@angular/core';
import { isToday, format } from 'date-fns';


@Injectable()
export class DateUtil {

    // Date转换为字符串:'yyyyy/MM/d'
    static formatYMD(date: Date) {
        if(date){
            const y = new Date(date).getFullYear();
            const m = new Date(date).getMonth() + 1;
            const d = new Date(date).getDate();
            return `${y}-${m}-${d}`;
        }
    }

    static formatYMDH(date: Date) {  
        if (date) {  
            const y = new Date(date).getFullYear().toString().padStart(4, '0');  
            const m1 = (new Date(date).getMonth() + 1).toString().padStart(2, '0');  
            const d = new Date(date).getDate().toString().padStart(2, '0');  
            const h = new Date(date).getHours().toString().padStart(2, '0');  
            const m2 = new Date(date).getMinutes().toString().padStart(2, '0');
            return `${y}-${m1}-${d} ${h}:${m2}`;  
        }  
        return null;
    }




    




}